<template>
  <div class="card table-container mt-4 mt-md-2" v-if="totalStreamerPage">
    <div class="card-header border-0 pl-2 pt-2">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Streamer Info</h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table :data="streamers">
        <template slot="columns">
          <th>Profile</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
          <!-- <th>Phone</th> -->
          <th>Edit</th>
          <th>Delete</th>
        </template>

        <template slot-scope="{row}">
          <td class="td-profile">
            <span class="avatar avatar-sm rounded-circle">
              <img
                :src="(row.streamerProfile !== 'null' && row.streamerProfile) ? row.streamerProfile : require('@/assets/default_profile_picture.png')"
              />
            </span>
          </td>
          <td>{{row.user.firstName}}</td>
          <td>{{row.user.lastName}}</td>
          <td>{{row.user.email}}</td>
          <!-- <td>{{row.user.phone}}</td> -->
          <td class="pl-1">
            <button class="btn btn-info" @click="onEditClicked(row.id)">
              <img src="@/assets/icons/ic_edit.svg" /> Edit
            </button>
          </td>
          <td class="pl-1">
            <button class="btn btn-delete" @click="onDeleteClicked(row)">
              <img src="@/assets/icons/ic_delete.svg" v-if="row.user.status === 'active'" />
              Delete
            </button>
          </td>
        </template>
      </base-table>
      <div class="card-footer d-flex justify-content-center">
        <base-pagination
          :page-count="totalStreamerPage"
          v-model="pagination"
          @input="onPageChanged"
        ></base-pagination>
      </div>
    </div>
    <modal :show.sync="showModal">
      <h6 slot="header" class="modal-title" id="modal-title-notification">Your attention is required</h6>

      <div class="text-center">
        <img src="@/assets/icons/ic_danger.svg" />
        <h3 class="mt-4">Are you sure want to delete this streamer?</h3>
      </div>

      <template slot="footer">
        <div class="col-md-12 text-center">
          <base-button outline type="primary" class="btn-cancel" @click="showModal = false">Cancel</base-button>
          <button class="btn btn-pirmary btn-delete default-button" @click="onConfirmDelete()">
            <img src="@/assets/icons/ic_delete.svg" width="13" height="13" class="mb-1" /> Delete
          </button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { GET_STREAMERS, UPDATE_USER_STATUS } from '@/store/actions.type'
import Progress from '@/common/progress'

export default {
  name: 'streamer-info-table',
  data() {
    return {
      streamer: null,
      showModal: false,
      pagination: 1
    }
  },
  created() {
    this.$store.dispatch(GET_STREAMERS, this.pagination)
  },
  methods: {
    onPageChanged(page) {
      Progress.show()
      this.$store
        .dispatch(GET_STREAMERS, page)
        .then(() => Progress.hide())
        .catch(() => Progress.hide())
    },
    onEditClicked(id) {
      this.$router.push({ path: `streamer/${id}` })
    },
    onDeleteClicked(streamer) {
      this.streamer = streamer
      this.showModal = true
      // if (streamer.user.status === 'active') {
      //   this.showModal = true
      // } else {
      //   this.updateStatus('active')
      // }
    },
    onConfirmDelete() {
      this.updateStatus('disabled')
    },
    updateStatus(status) {
      this.$store
        .dispatch(UPDATE_USER_STATUS, {
          id: this.streamer.user.id,
          status: status
        })
        .then(() => {
          this.streamer.user.status = status
          this.showModal = false
          this.$store.dispatch(GET_STREAMERS, this.pagination)
        })
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.user.isLoading,
      error: state => state.user.errror
    }),
    ...mapGetters(['totalStreamerPage', 'streamers'])
  }
}
</script>

<style scoped>
/* .card-header hr {
  border-top: 1px solid rgba(225, 225, 225, 0.5) !important;
  margin-top: 0 !important;
}
.card-header {
  border-radius: 15px !important;
  box-shadow: 0 4px 8px 0 rgba(255, 255, 255, 0.2),
    0 6px 20px 0 rgba(92, 92, 92, 0.19);
} */

.btn-info {
  padding: 0.45rem 0.8rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
}
.btn-delete {
  padding: 0.45rem 0.8rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
  background-color: #f65858;
}
.btn-delete:hover {
  background-color: #f65858;
}
.btn-success {
  padding: 0.45rem 1.2rem !important;
  font-size: 0.65rem !important;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
}
.btn-cancel {
  border-color: #f65858 !important;
  color: #f65858 !important;
}
.btn-cancel:hover {
  background-color: transparent !important;
}
.default-button {
  padding: 0.625rem 1.25rem !important;
  font-size: 0.875em !important;
}
</style>
